import { render } from "./terms-condition.vue?vue&type=template&id=2c50b3d4&scoped=true"
import script from "./terms-condition.vue?vue&type=script&lang=js"
export * from "./terms-condition.vue?vue&type=script&lang=js"

import "./terms-condition.vue?vue&type=style&index=0&id=2c50b3d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c50b3d4"]])

export default __exports__